import { memo, useMemo } from "react"
import { MOBILE_ICONS } from "../../../../data/variables"
import Icon from "../../../../components/Icon"

import './index.scss'

type Row = {
  mobiles: {
    cust_icon: string
  }[]
}

type FleetIconsColumn = {
  row: Row
}

const DEFAULT_ICON = 'arrow_blue'

const FleetIconsColumn = memo(({ row }: FleetIconsColumn) => {
  const availableIcons = useMemo(() => {
    const icons = row.mobiles.reduce((obj, val) => {
      const icon = val.cust_icon ?? DEFAULT_ICON
      if (!obj[icon]) obj[icon] = MOBILE_ICONS[icon]
      return obj
    }, {})

    return icons
  }, [row])

  return (
    <div className="FleetIconsColumn">
      {Object.keys(availableIcons).map((key) => {
        const icon = availableIcons[key]
        if (icon) {
          return <Icon key={key} icon={icon.icon} color={icon.color} />
        }
      })}
    </div>
  )
})

export default FleetIconsColumn
